import { gql, TypedDocumentNode } from '@apollo/client';

import { Match, QueryFindMatchForJobPositionArgs } from '@pflegia/data-access';

export const FIND_MATCH_FOR_JOB_POSITION: TypedDocumentNode<{ findMatchForJobPosition: Match }, QueryFindMatchForJobPositionArgs> = gql`
  query FindMatchForJobPosition($jobPositionId: UUID!) {
    findMatchForJobPosition(jobPositionId: $jobPositionId) {
      id
      invitationText
      connectionType
      connectionStatus
      updatedAt
      offerType
      inviteAcceptSource
      isMachineLearningInvite
    }
  }
`;
